import { makeStyles } from '@material-ui/core';

import { blue, gradient, neutral, purple, yellow } from 'shared/styles/colors';

import type { UserTagType } from 'shared/domain';

export default makeStyles({
  root: (props: Props) => ({
    padding: '0.125rem 0.5rem',
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    fontSize: '0.625rem',
    lineHeight: '1.125rem',
    letterSpacing: '0.012em',
    cursor: 'pointer',
    borderRadius: '1rem',
    ...getCSSValues(props),
  }),
});

function getCSSValues({ userTag }: Props) {
  let color: string = purple['60'];
  let background: string = purple['10'];
  let borderColor: string = background;
  if (userTag === 'new') {
    color = blue['50'];
    background = blue['10'];
    borderColor = background;
  } else if (userTag === 'pro') {
    color = yellow['50'];
    background = gradient.black;
    borderColor = neutral['90'];
  }
  return {
    color,
    background,
    border: `1px solid ${borderColor}`,
  };
}

interface Props {
  userTag: UserTagType;
}
